<template>
<b-container fluid class="borde">
    <b-alert variant="ligth" show>
      <b-link href="#">Interaccion 2023</b-link> 
    ||
      <b-link href="http://www.udl.cat/">Universitat de Lleida</b-link>.
  <!-- <b-img src ="../assets/img/logoAIPO.png" width="80" height="80" alt="Logo AIPO"> </b-img> 
 <b-img src ="../assets/img/logoUdL.png" width="160" height="60" alt="Logo Universitat de Lleida"></b-img> 
-->
 

    </b-alert>
    </b-container >
</template>

<script>
export default {


}
</script>


<style scoped>
.borde{
  border: 1px solid grey;
}
</style>